<script>
import { mapActions } from "vuex";
import AggregatorsTable from "./AggregatorsTable";

export default {
	name: "server-table",
	components: { AggregatorsTable },
	data() {
		return  {
			headers: [
				{
					text: "Name",
					value: "name",
					align: "left"
				},
				{
					text: "Status",
					value: "status"
				},
				{
					text: "Admin Auth check",
					value: "authen"
				},
				{
					text: "Version",
					value: "version",
				},
				{
					text: "",
					value: "actions",
					align: "right",
					sortable: false
				},
				{
					text: "",
					value: "data-table-expand"
				}
			],
			serverResponse: [],
			expanded: [],
			search: "",
			isLoading: false
		};
	},
	methods: {
		...mapActions("request", ["fetchServersList", "fetchServersDetails"]),
		getServers() {
			this.isLoading = true;
			return this.fetchServersList()
				.then(serverList => this.getServerInfo(serverList))
				.then(() => {
					this.isLoading = false;
				})
				.catch(e => {
					console.log(e);
					this.isLoading = false;
				});
		},
		getServerInfo(servers) {
			return Promise.all(servers.map(server => {
				let serverListElement = {
					name: server.name,
				}
				this.serverResponse.push(serverListElement);

				return this.fetchServersDetails(server.name)
					.then(serverDetails =>
						this.updateListedServer(serverListElement, serverDetails));
			}));
		},
		updateListedServer(listElement, updateInfo) {
			for (let key in updateInfo) {
				listElement[key] = updateInfo[key];
			}

			listElement.__ob__.dep.notify();
		}
	},
	mounted() {
		this.getServers();
	}
};
</script>

<template>
	<div>
		<v-text-field
			v-model="search"
			label="Search"
			append-icon="mdi-magnify"
			single-line
			hide-details
		/>
		<v-data-table
			:headers="headers"
			:items="serverResponse"
			item-key="name"
			:items-per-page="15"
			:expanded.sync="expanded"
			show-expand
			:search="search"
			:loading="isLoading"
			loading-text="Loading servers..."
			:footer-props="{
				showFirstLastPage: true
			}"
		>
			<template v-slot:item="{ item, expand, isExpanded }">
				<tr>
					<td>
						<a :href="item.dashboardUrl">
							<v-icon small>
								mdi-monitor-dashboard
							</v-icon>
						</a>
						<a :href="item.appUrl">
							<v-icon small>
								mdi-cellphone-text
							</v-icon>
						</a>
						{{ item.name }}
					</td>
					<td>
						<v-icon x-small class="statusIcon" :color="item.status === 'Online' ? 'success' : 'warning'">
							mdi-circle
						</v-icon>
						{{ item.status }}
					</td>
					<td>
						<v-icon v-if="item.authen === 'Pass'">
							mdi-check
						</v-icon>
						<span
							v-else-if="item.authen === 'Please change default password'"
							color="warning"
						>
							Please change default password
						</span>
						<v-tooltip v-else bottom>
							<template v-slot:activator="{ on, attrs }">
								<v-icon
									color="warning"
									v-bind="attrs"
									v-on="on"
								>
									mdi-alert
								</v-icon>
							</template>
							<span>{{ item.authen }}</span>
						</v-tooltip>
					</td>
					<td>
						{{ item.version }}
					</td>
					<td>
						<router-link :to="{name:'serverInfo', params:{serverName: item.name}}">
							<v-icon>mdi-information</v-icon>
						</router-link>
					</td>
					<td>
						<v-icon
							@click="expand(!isExpanded)"
							:class="{'expand-icon': true, 'expanded': isExpanded}"
						>mdi-chevron-down</v-icon>
					</td>
				</tr>
			</template>

			<template v-slot:expanded-item="{headers, item}">
				<td :colspan="headers.length"	class="subTable">
					<aggregators-table :key="item.name" :domain="item.name" class="aggregatorsTable"/>
				</td>
			</template>
		</v-data-table>
	</div>
</template>

<style lang="scss" scoped>
a {
	text-decoration: none;
}
.v-input {
	padding: 5px
}
.statusIcon {
	vertical-align: initial;
}
.expand-icon {
	transform: rotate(0deg);
	transition: transform 0.2s linear;
	&.expanded {
		transform: rotate(-180deg);
	}
}
.subTable {
	padding: 0;
	.aggregatorsTable {
		border-radius: 0;
		box-shadow: inset 0 4px 8px -5px rgba(50,50,50,.75),inset 0 -4px 8px -5px rgba(50,50,50,.75);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/elements/ServerTable.vue